import { ModuleWithProviders, NgModule } from '@angular/core';
import { OrganizationServicesComponent } from '@spaq/modules/organization/pages';
import { ServicesModule } from '@spaq/modules/services';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { OrganizationDetailsComponent } from './components';

@NgModule({
	imports: [SharedCommonModule, ServicesModule, SharedComponentsModule, SharedCommonModule],
	declarations: [OrganizationDetailsComponent, OrganizationServicesComponent],
	exports: [OrganizationDetailsComponent, OrganizationServicesComponent]
})
export class OrganizationsModule {
	static forRoot(): ModuleWithProviders<OrganizationsModule> {
		return {
			ngModule: OrganizationsModule,
			providers: []
		};
	}
}
